import { __assign } from "tslib";
import Talometer, { default_options } from "../talometer";
import { writable } from 'svelte/store';
var options = writable(default_options);
export var talometer = writable(new Talometer());
export var talometer_options = __assign(__assign({}, options), { setBPM: function (value) { return options.update(function (self) {
        self.bpm = value;
        return self;
    }); }, setTalaVolume: function (value) { return options.update(function (self) {
        self.talaVolume = value;
        return self;
    }); }, setTanpuraVolume: function (value) { return options.update(function (self) {
        self.tanpuraVolume = value;
        return self;
    }); } });
